<template>
  <div class="spaceChoose">
    <a @touchstart="close" @click="close" class="pointer text-white" style="float: right;font-size: 0.9rem;z-index: 10">关闭</a>
    <el-tabs v-model="activeId">
      <el-tab-pane label="树形视图" name="1">
        <div class="current-location" style="margin-right: 21px;padding-bottom: 10px;">
          <el-input class="inline-input" v-model="name" placeholder="请输入搜索的空间名称" size="mini"
                    @change="changeName"/>
        </div>
        <space-tree-show :space-id="selectSpaceInfo.id ? selectSpaceInfo.id : null" @spaceChoose="spaceClick"
                         ref="spaceTree"></space-tree-show>
      </el-tab-pane>
      <el-tab-pane label="地图视图" name="2" style="height: 50vh;">
        <brick-map-chart :data="data" @spaceChoose="spaceClick" ref="mapChart" style="height: 100%;"></brick-map-chart>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SpaceTreeShow from "@/components/space/SpaceTreeShow";
import {getProvinceSpace} from "@/network/space-info";
import BrickMapChart from "@/components/echarts/BrickMapChart";

export default {
  name: "SpaceChoose",
  props: ['currentSpaceInfo'],
  components: {
    SpaceTreeShow, BrickMapChart
  },
  data() {
    return {
      name:"",
      activeId: "1",
      data: [],
      selectSpaceInfo: {}
    }
  },
  watch:{
    currentSpaceInfo(){
      this.selectSpaceInfo = this.currentSpaceInfo
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      getProvinceSpace().then(res => {
        if (res.code === 0) {
          this.data = res.data
        }
      })
    },
    close() {
      this.$emit('close')
    },
    //更换按钮
    spaceClick(data, init) {
      // 防止重复处理相同的节点
      if (this.selectSpaceInfo && this.selectSpaceInfo.id === data.id && !init) {
        return;
      }
      
      this.activeId = "1";
      this.selectSpaceInfo = data;
      
      // 确保只发送一次事件
      this.$emit('spaceClick', data, init);
    },
    //节点选中
    selectNode(spaceData) {
      if (!spaceData || !spaceData.id || !this.$refs.spaceTree) {
        return;
      }
      
      try {
        const firstTree = this.$refs.spaceTree.selectedSpace(spaceData.id);
        if (firstTree && this.$refs.spaceTree.ztreeObj) {
          this.$refs.spaceTree.ztreeObj.selectNode(firstTree);
        }
      } catch (e) {
        console.error('选择节点失败:', e);
      }
    },
    changeName(){
      this.$refs.spaceTree.changName(this.name);
    }
  }
}
</script>

<style scoped>

.spaceChoose {
  display: inline-block;
  position: absolute;
  top: 100px;
  left: 50px;
  min-height: 60vh;
  max-height: 870px;
  z-index: 999;
  background-color: rgba(0, 62, 119, .9);
  width: 380px;
  padding: 10px 15px 20px 10px;
}

.spaceChoose .el-tabs >>> .el-tabs__header {
  position: inherit;
}
</style>
